import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navbarLinks } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2">
          <span className="font-heading text-2xl md:text-3xl font-black text-foreground-900 tracking-tight">
            Han<span className="text-primary-500">Man</span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navbarLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-10 h-10 rounded-full flex items-center justify-center text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer">
            <i className="ri-search-line text-lg"></i>
          </button>
          <Link
            to="/category"
            className="bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
        </div>

        <button
          className="md:hidden w-10 h-10 rounded-full flex items-center justify-center text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-6 py-4 flex flex-col gap-3">
          {navbarLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => setMobileOpen(false)}
              className={`text-sm font-medium py-2 transition-colors ${
                location.pathname === link.href
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-foreground-950'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/category"
            onClick={() => setMobileOpen(false)}
            className="bg-primary-500 text-background-50 text-center px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer mt-2"
          >
            开始阅读
          </Link>
        </div>
      )}
    </nav>
  );
}